// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Colors } from "../../../assets/Colors";
import { JurnalTable } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { useForm } from "../../../components/isRequired";
import { useMutation } from "@tanstack/react-query";
import { fetchPostSilance } from "../../../fetchers";
import { toast } from "react-toastify";
import { maxPageGlobal } from "../../../assets/config";

const ReportJurnalPage = ({}) => {
  let initialState = {
    TanggalAwal: new Date(),
    TanggalAkhir: new Date(),

    BisnisUnitID: "U0002",
  };

  const validations = [];

  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const [data, setData] = useState(null);
  const [dataUpkeep, setDataUpkeep] = useState(null);
  const mutationData = useMutation((param) =>
    fetchPostSilance("Accounting/Journal", param)
  );
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [level, setLevel] = useState("per-akun");
  // Filter sumber data. Nilainya harus sama persis dgn sumberJurnalSQL di backend
  // (accounting.go): "ALL" | "KAS" | "BANK" | "PO" | "UMUM".
  const sumberDataOptions = [
    { key: "ALL", label: "Semua Sumber" },
    { key: "KAS", label: "Kas All" },
    { key: "BANK", label: "Bank All" },
    { key: "PO", label: "PO" },
    { key: "UMUM", label: "Jurnal Umum" },
  ];
  const [sumberData, setSumberData] = useState("ALL");
  const today = new Date();
  const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    TanggalAwal: firstOfMonth,
    TanggalAkhir: today,
    SumberData: "ALL",
  });
  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const header = [
    { name: "Tanggal", key: "Tanggal" },
    { name: "No Jurnal", key: "AccountingID", modifiers: "Text" },
    { name: "No Akun", key: "NomorAccount", modifiers: "Text" },
    { name: "Nama Akun", key: "NamaAccount", modifiers: "Text" },
    { name: "Debet", key: "TotalDebet", modifiers: "Number" },
    { name: "Credit", key: "TotalKredit", modifiers: "Number" },
  ];

  const filterData = (event) => {
    const filtered = dataUpkeep.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setData(filtered);
  };
  const filterApi = () => {
    setParam({
      start: start,
      count: count,
      search: "",
      BisnisUnitID: values.BisnisUnitID,
      TanggalAwal: values.TanggalAwal,
      TanggalAkhir: values.TanggalAkhir,
      SumberData: sumberData,
    });
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                  <div className={"w-1/5"}>
                    <HrdInputGenerator
                      type={"BisnisUnit"}
                      name={"BisnisUnitID"}
                      title={"BisnisUnit"}
                      value={values}
                      required={true}
                      includeAll={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/5"}>
                    <HrdInputGenerator
                      type={"dateOnly"}
                      name={"TanggalAwal"}
                      title={"Tanggal Awal"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/5"}>
                    <HrdInputGenerator
                      type={"dateOnly"}
                      name={"TanggalAkhir"}
                      title={"Tanggal Akhir"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/5 pr-2"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Sumber Data
                    </label>
                    <select
                      name="SumberData"
                      value={sumberData}
                      onChange={(e) => setSumberData(e.target.value)}
                      className="block w-full bg-white text-gray-700 border border-gray-300 rounded py-2 px-3 text-sm leading-tight focus:outline-none focus:ring-4 focus:ring-blue-300"
                    >
                      {sumberDataOptions.map((opt) => (
                        <option key={opt.key} value={opt.key}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={"w-1/5"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>

                    <button
                      type="button"
                      onClick={filterApi}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                    >
                      Buka
                    </button>
                  </div>
                </div>

                <div className="flex flex-row items-center gap-2 px-4 py-2">
                  <span className="text-xs font-bold text-gray-600 uppercase mr-2">Level Detail:</span>
                  {[
                    { key: "summary", label: "Summary" },
                    { key: "per-akun", label: "Per Akun" },
                    { key: "detail", label: "Full Detail" },
                  ].map((opt) => (
                    <button
                      key={opt.key}
                      type="button"
                      onClick={() => setLevel(opt.key)}
                      className={`text-sm px-4 py-1 rounded border font-medium transition-colors ${
                        level === opt.key
                          ? "bg-main-100 text-white border-main-100"
                          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                      }`}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>

                <div className="flex flex-col items-center content-center ">
                  <JurnalTable
                    data={mutationData.data}
                    header={header}
                    menuController={filterData}
                    name={"Nama"}
                    title={"Report Jurnal"}
                    level={level}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportJurnalPage;
